import React from "react"
import { Grid, Col, Row } from "react-styled-flexboxgrid"
import styled, { ThemeProvider } from "styled-components"
import { observer } from "mobx-react"
import Link from "next/link"
import Image from "next/image"
import Inc500 from "~/public/static/images/png/Inc500.png"
import useFooterLinks from "./useFooterLinks"

const GRID_THEME = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 1, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    container: {
      sm: 28, // rem
      md: 35, // rem
      lg: 76 // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 30, // em
      md: 45, // em
      lg: 75 // em
    }
  }
}

const LinkGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px 0;
  flex-direction: column;
  color: ${props => props.theme.colors.text.mainFooter};
  h4 {
    display: block;
    width: 100%;
    font-family: ${props => props.theme.fonts.avenirNextDemi};
    margin: 0;
    font-size: 1.0625em;
    color: ${props => props.theme.colors.text.mainFooter};
  }

  ul {
    padding-inline-start: 0px;
    list-style-position: inside;
    list-style: none;
    li {
      line-height: 1.6875em;
      padding: 0px;
      font-size: 1.0625em;
    }
  }
  font-family: ${props => props.theme.fonts.avenirNextRegular};
`

const FooterLink = styled.a`
  color: ${props => props.theme.colors.old.footerText};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const ActionLinkBuilder = link => {
  if (link.external) {
    return <FooterLink href={link.href}>{link.title}</FooterLink>
  }
  if (link.href) {
    return (
      <Link href={link.href} passHref>
        <FooterLink>{link.title}</FooterLink>
      </Link>
    )
  }
  if (link.onClick) {
    return (
      <FooterLink href="#" onClick={link.onClick}>
        {link.title}
      </FooterLink>
    )
  }
  if (link.opener) {
    return (
      <link.Component
        opener={({ onClick }) => (
          <FooterLink href="#" onClick={onClick}>
            {link.title}
          </FooterLink>
        )}
      />
    )
  }
  return <div />
}

const FooterTableLinks = () => {
  const links = useFooterLinks()

  return (
    <ThemeProvider theme={GRID_THEME}>
      <Grid style={{ width: "100%" }}>
        <Row>
          <Col xs={12} sm={6} md={3} lg={3}>
            <LinkGroup>
              <Image
                src={Inc500}
                alt="Featured in Inc. 500 Americas Fastest-Growing Private Companies."
                width={160}
                height={160}
              />
            </LinkGroup>
          </Col>
          {links.map(group => (
            <Col
              xs={12}
              sm={group.sizes.sm}
              md={group.sizes.md}
              lg={group.sizes.lg}
              key={group.title}
            >
              <LinkGroup>
                <h4>{group.title}</h4>
                <ul>
                  {group.links.map(link => {
                    if (!link) return null
                    return <li key={link.title}>{ActionLinkBuilder(link)}</li>
                  })}
                </ul>
              </LinkGroup>
            </Col>
          ))}
        </Row>
      </Grid>
    </ThemeProvider>
  )
}

export default observer(FooterTableLinks)
